import axios from 'axios';


const apiURL = process.env.VUE_APP_API_URL;

/* Send session cookies : therefor withCredentials must be true */
export const APIServices = axios.create({
  baseURL: apiURL
});
